export default __webpack_public_path__ + "media/color/flo-5b325f06.svg";